import { ContractTermination } from "@entity/domain/models/employee/contracts/termination/contract-termination.model";
import { CreateContractTermination } from "@entity/domain/models/employee/contracts/termination/create-contract-termination.model";

export class EditContractTermination extends CreateContractTermination {
    constructor(
        public readonly id: ContractTermination["id"],
        terminationCategory: CreateContractTermination["terminationCategory"],
        startDate: CreateContractTermination["startDate"],
        reason: CreateContractTermination["reason"],
        type: CreateContractTermination["type"],
        contractId: CreateContractTermination["contractId"],
        medicalLeaveSubtype?: CreateContractTermination["medicalLeaveSubtype"],
        cost?: CreateContractTermination["cost"],
        totalCost?: CreateContractTermination["totalCost"],
        endDate?: CreateContractTermination["endDate"],
        medicalLeavePeriods?: CreateContractTermination["medicalLeavePeriods"],
    ) {
        super(
            terminationCategory,
            startDate,
            reason,
            type,
            contractId,
            medicalLeaveSubtype,
            cost,
            totalCost,
            endDate,
            medicalLeavePeriods,
        );
    }
}
